export class TextAdvertisement {
    personalize: boolean;
    title: string;
    body: string;
    imgUrls: string[];
    females: boolean;
    males: boolean;
    disciplines: string[];
    rodeoEvents: number[];
    schedules: number[];
    rodeos: number[];

    constructor() {
        this.personalize = true;
        this.females = true;
        this.males = true;
    }
}


// WEBPACK FOOTER //
// ./src/model/textAdvertisement.ts